import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Calendar from "react-calendar";
import MiniCalendar from "../calendarpage/MiniCalendar";
import {
  Avatar,
  Card,
  Divider,
  IconButton,
  Button,
  Typography,
  Modal,
  Link,
  OutlinedInput,
  useMediaQuery,
  Select,
  MenuItem,
} from "@mui/material";
import {
  AccessTime,
  AccessTimeFilled,
  Add,
  ArrowBack,
  Language,
  LocationOn,
  Person,
  Phone,
} from "@mui/icons-material";
import { gql, useMutation, useQuery } from "@apollo/client";
import Times from "../calendarpage/Times";
import {
  addDays,
  addMinutes,
  addMonths,
  addWeeks,
  addYears,
  differenceInDays,
  differenceInMinutes,
  differenceInMonths,
  differenceInWeeks,
  differenceInYears,
  eachMinuteOfInterval,
  endOfDay,
  format,
  isAfter,
  isBefore,
  isSameDay,
  isSameHour,
  isSameMinute,
  isSameMonth,
  isWithinInterval,
  parse,
  startOfDay,
  subDays,
} from "date-fns";
import Error from "../Error";
import {
  getBookings,
  getCompanyHours,
  getOverrideGroups,
  getOverrides,
  getRatings,
  getUsers,
} from "../../graphql/querys";
import { Rating, LinearProgress, Box } from "@mui/material";
import { ADD_RATING, GET_RATING_DETAILS } from "../../graphql/mutations";
import HourFormat from "../../util/hourFormat";
import { Timezones_List } from "../../util/timezones";
import { zonedTimeToUtc } from "date-fns-tz";
import {
  converterDateTime,
  ethDateTime,
  toEthiopianDateTime,
} from "../../util/Ethiopia/Ethiopia";
const NotFound = () => {
  return <Error />;
};

const CancelModal = ({
  showCancelModal,
  setShowCancelModal,
  bookingId,
  setBookingId,
  review,
  setReview,
  desc,
  addRating,
  data,
  refetch,
  setDesc,
  rating,
  setRating,
  errors,
  setErrors,
}) => {
  return (
    <Modal open={showCancelModal} onClose={() => setShowCancelModal(false)}>
      <Box
        className="flex column"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "10px",
          outline: "none",
          maxWidth: "400px",
          gap: "10px",
        }}
      >
        <Typography variant="h4">Post a Rating</Typography>
        <div>
          <Typography
            variant="h6"
            className="flex align"
            style={{ gap: "5px" }}
          >
            Your Booking Id
            <Typography className="font2" style={{ fontSize: "13px" }}>
              (Check your email)
            </Typography>
          </Typography>
          <OutlinedInput
            onChange={(e) => {
              setBookingId(e.target.value);
              setErrors(null);
            }}
            value={bookingId}
            fullWidth
            style={{ maxWidth: "500px", width: "300px" }}
          />
        </div>
        <div>
          <Typography variant="h6">Rating</Typography>
          <Rating
            onChange={(e) => {
              setRating(e.target.value);
              setErrors(null);
            }}
            value={rating}
          />
        </div>
        <div>
          <Typography variant="h6">Review</Typography>
          <OutlinedInput
            onChange={(e) => {
              setReview(e.target.value);
              setErrors(null);
            }}
            value={review}
            fullWidth
            style={{ maxWidth: "400px" }}
          />
        </div>
        <div>
          <Typography variant="h6">Description</Typography>
          <OutlinedInput
            onChange={(e) => {
              setDesc(e.target.value);
              setErrors(null);
            }}
            value={desc}
            multiline
            rows={4}
            fullWidth
            style={{ maxWidth: "400px" }}
          />
        </div>
        {errors && <Typography style={{ color: "red" }}>{errors}</Typography>}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={() => setShowCancelModal(false)}
            sx={{ mr: 2 }}
          >
            Nevermind
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (!rating || !desc || !review || !bookingId) {
                setErrors("Please provide a value for the inputs");
                return;
              }
              addRating({
                variables: {
                  eventId: parseInt(data.id),
                  rating: parseInt(rating),
                  desc,
                  review,
                  bookingId,
                },
              })
                .then((val) => {
                  setShowCancelModal(false);
                  refetch();
                })
                .catch((err) => {
                  console.log(err.message);
                  setErrors(err.message);
                });
            }}
            style={{ background: "#d9bca9" }}
          >
            POST
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
const EventPage = (props) => {
  const { id } = useParams();
  const data = props.allEvents.find((obj) => obj.link == id);
  useEffect(() => {
    props.setImage(data?.image);
  }, []);
  const { user } = useParams();
  const {
    loading: companyLoading,
    error: companyError,
    data: companyData,
    refetch: companyRefetch,
  } = useQuery(getCompanyHours, {
    variables: {
      userId: parseInt(props?.usersData.id), // Replace with the user ID you want to filter by
      hours24: HourFormat(),
      sorted: true,
    },
  });
  const {
    loading,
    error,
    data: ratingsData,
    refetch,
  } = useQuery(getRatings, {
    variables: { eventId: parseInt(data?.id) },
  });
  const {
    loading: overrideGroupLoading,
    error: overrideGroupError,
    data: overrideGroupData,
    refetch: overrideGroupRefetch,
  } = useQuery(getOverrideGroups, {
    variables: {
      userId: parseInt(props.usersData.id), // Replace with the user ID you want to filter by
    },
  });
  const {
    loading: overrideLoading,
    error: overrideError,
    data: overrideData,
    refetch: overrideRefetch,
  } = useQuery(getOverrides, {
    variables: {
      userId: parseInt(props.usersData.id), // Replace with the user ID you want to filter by
    },
  });
  const {
    loading: bookloading,
    error: bookerror,
    data: bookdata,
  } = useQuery(getBookings);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isSmallScreen2 = useMediaQuery("(max-width:900px)");
  const [showMore, setShowMore] = useState(
    data?.desc?.length > 300 ? true : null
  );
  const [isItLoading, setIsItLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const navigate = useNavigate();
  const [currentMonth, setCurrentMonth] = useState(null);
  function findit(e, fornows) {
    var count = 0;
    for (let i = 0; i < fornows.length; i++) {
      if (
        new Date(fornows[i].time).getFullYear() == e.getFullYear() &&
        new Date(fornows[i].time).getDate() == e.getDate() &&
        new Date(fornows[i].time).getHours() == e.getHours() &&
        new Date(fornows[i].time).getMinutes() == e.getMinutes()
      ) {
        count++;
      }
    }
    return count
      ? data?.maxInvitees
        ? data?.maxInvitees - count <= 0
          ? false
          : data?.maxInvitees - count
        : count
      : false;
  }
  function checks(time, selectedDatee) {
    var actualTime = new Date(selectedDatee || selectedDate).setHours(
      parse(
        time,
        HourFormat(),
        new Date(selectedDatee || selectedDate)
      ).getHours(),
      parse(
        time,
        HourFormat(),
        new Date(selectedDatee || selectedDate)
      ).getMinutes()
    );
    actualTime = new Date(actualTime);
    var fornows = bookdata.getBookings.filter(
      (obj) =>
        new Date(actualTime).getFullYear() ===
        new Date(obj.time).getFullYear() &&
        new Date(actualTime).getDate() === new Date(obj.time).getDate() &&
        new Date(actualTime).getHours() === new Date(obj.time).getHours() &&
        new Date(actualTime).getMinutes() === new Date(obj.time).getMinutes() &&
        obj.eventId == data?.id
    );
    var fornows2 = bookdata.getBookings.filter(
      (obj) =>
        new Date(actualTime).getFullYear() ===
        new Date(obj.time).getFullYear() &&
        new Date(actualTime).getDate() === new Date(obj.time).getDate() &&
        obj.eventId == data?.id
    );
    if (
      data?.eventsPerDay !== null &&
      fornows2?.length &&
      data?.eventsPerDay == fornows2?.length
    ) {
      return "late";
    }
    if (
      differenceInMinutes(parse(time, HourFormat(), new Date()), new Date()) <
      0 &&
      isSameDay(new Date(), new Date(selectedDatee || selectedDate))
    ) {
      return "late";
    }
    if (fornows.length == 0) {
      return data?.maxInvitees ? data?.maxInvitees : true;
    }
    return data?.eventType == "group" ? findit(actualTime, fornows) : "one";
  }
  function getTimezoneInfo(timezone) {
    return Timezones_List.find((val) => val.id == timezone);
  }
  function findTimes(arr, start, end, selectedDate, spilled) {
    if (!start || !end) {
      return false;
    }
    var startTime = parse(
      start,
      start.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
      selectedDate
    );
    var endTime = parse(
      end,
      end.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
      selectedDate
    );
    if (isBefore(endTime, startTime)) {
      endTime = addDays(endTime, 1);
    }

    const timestamps = eachMinuteOfInterval({
      start: startTime,
      end: endTime,
    });
    var thirtyMinuteIntervals = timestamps.filter((time, index) => {
      return (
        isWithinInterval(new Date(addMinutes(time, data?.length)), {
          start: startTime,
          end: endTime,
        }) && index % data?.increments === 0
      );
    });

    const userTimeZone = getTimezoneInfo(props.usersData.timezone).timezone;
    const timeFormat = "yyyy-MM-dd HH:mm:ss";

    thirtyMinuteIntervals = thirtyMinuteIntervals.filter(
      (date, index, self) =>
        index ==
        self.findIndex((t) => isSameHour(t, date) && isSameMinute(t, date))
    );
    function isTimeWithinSelectedDay(time) {
      return (
        (isAfter(time, startOfDay(new Date(selectedDate))) &&
          isBefore(time, endOfDay(new Date(selectedDate)))) ||
        isSameDay(time, startOfDay(new Date(selectedDate)))
      );
    }
    var spilledTimes = { after: [], before: [] };
    thirtyMinuteIntervals.forEach((time) => {
      // Create a new date object in the company's timezone
      const timeInCompanyTimezone = zonedTimeToUtc(
        format(time, timeFormat),
        userTimeZone
      );

      // Then, you can convert this time to the user's timezone
      const formattedTime = format(
        new Date(timeInCompanyTimezone),
        HourFormat()
      );

      const checksResult = checks(formattedTime, selectedDate);
      if (checksResult !== "late" && checksResult !== "one") {
        const isTimeWithinDay = isTimeWithinSelectedDay(timeInCompanyTimezone);
        if (isTimeWithinDay) {
          arr.push(format(timeInCompanyTimezone, "h:mmaa"));
        } else {
          if (
            !isAfter(timeInCompanyTimezone, startOfDay(new Date(selectedDate)))
          ) {
            spilledTimes["before"].push(
              format(timeInCompanyTimezone, "h:mmaa")
            );
          } else if (
            !isBefore(timeInCompanyTimezone, endOfDay(new Date(selectedDate)))
          ) {
            spilledTimes["after"].push(format(timeInCompanyTimezone, "h:mmaa"));
          }
        }
      }
    });
    if (spilled) {
      return spilledTimes;
    }
  }
  function getData(date) {
    var theOne = overrideGroupData?.getOverrideGroups.find((val) => {
      return (
        isSameDay(new Date(date), new Date(val.date)) &&
        val.groupId == data.groupId
      );
    });
    return theOne
      ? overrideData?.getOverrides
        .filter((val) => val.groupId == theOne.id)
        .map((val) => {
          return {
            day: format(new Date(theOne.date), "EEEE"),
            groupId: theOne.groupId,
            userId: parseInt(props.usersData.id),
            startTime: val.startTime,
            endTime: val.endTime,
            id: val.id,
            onJob: true,
          };
        })
      : companyData?.getCompanyHours.filter(
        (obj) =>
          obj.day === format(new Date(date), "EEEE") &&
          data.groupId == obj.groupId
      ) || {};
  }
  const cache = useRef({});
  function habeshaAddMonths(date, i) {
    let ethDate = converterDateTime.toEthiopian(date);
    let newMonth = ethDate.month;
    let newYear = ethDate.year;

    // Calculate the new month and adjust the year if necessary
    newMonth += i;

    // Handle negative month values
    while (newMonth <= 0) {
      newMonth += 12;
      newYear -= 1;
    }

    // Calculate the number of years to add or subtract
    let yearsToAdd = Math.floor(newMonth / 12);

    // Calculate the remaining months
    newMonth = newMonth % 12;

    if (newMonth === 0) {
      newMonth = 12;
      yearsToAdd -= 1;
    }

    // Add the years to the new year
    newYear += yearsToAdd;
    return converterDateTime.toEuropean(
      new ethDateTime(ethDate.date, newMonth, newYear)
    );
  }
  function isDateGood(date, e) {
    var a = date.setHours(0, 0, 0, 0);
    var b = new Date().setHours(0, 0, 0, 0);
    var startt = new Date(data.start).setHours(0, 0, 0, 0);
    var endd = getEndDate(data.end).setHours(0, 0, 0, 0);
    if (cache.current[a] !== undefined) {
      return cache.current[a];
    } else {
      setIsItLoading(true);
      cache.current[a] = "computing";
    }

    // Calculate recurring dates for 'end'
    var recurringDates;
    var good = true;
    const array = ["week", "month", "year", "day"];
    var check = false;
    if (
      array.includes(data.end.split(" ")[0]) ||
      !isNaN(Number(data.end.split(" ")[0]))
    ) {
      recurringDates = getRecurringDates(
        data.end,
        e || !currentMonth ? new Date() : currentMonth
      );
      good = recurringDates.some((val) => isSameDay(new Date(a), val));
      check = true;
    }
    var theOne = overrideGroupData?.getOverrideGroups.find((val) => {
      return (
        isSameDay(new Date(selectedDate), new Date(val.date)) &&
        val.groupId == data.groupId
      );
    });
    var find = theOne
      ? overrideData?.getOverrides
        .filter((val) => val.groupId == theOne.id)
        .map((val) => {
          return {
            day: format(new Date(theOne.date), "EEEE"),
            groupId: theOne.groupId,
            userId: props.usersData.id,
            startTime: val.startTime,
            endTime: val.endTime,
            id: val.id,
            onJob: true,
          };
        })
      : companyData?.getCompanyHours.filter(
        (obj) =>
          obj.day === format(new Date(date), "EEEE") &&
          data.groupId == obj.groupId
      ) || {};
    find = find.filter(
      (date, index, self) =>
        index ==
        self.findIndex(
          (t) =>
            t.startTime.toLowerCase() == date.startTime.toLowerCase() &&
            t.endTime.toLowerCase() == date.endTime.toLowerCase()
        )
    );
    var enddd = Date.now(); // End time
    let tempTimesyest = [];
    let tempTimes = [];
    let tempTimestmrw = [];
    for (let i = 0; i < find.length; i++) {
      findTimes(tempTimes, find[i].startTime, find[i].endTime, date);
    }
    for (let i = 0; i < getData(subDays(date, 1)).length; i++) {
      var dataa = getData(subDays(date, 1));
      tempTimesyest = findTimes(
        tempTimesyest,
        dataa[i].startTime,
        dataa[i].endTime,
        subDays(date, 1),
        1
      ).after;
    }

    for (let i = 0; i < getData(addDays(date, 1)).length; i++) {
      var dataa = getData(addDays(date, 1));
      tempTimestmrw = findTimes(
        tempTimestmrw,
        dataa[i].startTime,
        dataa[i].endTime,
        addDays(date, 1),
        1
      ).before;
    }

    tempTimesyest.map((val) =>
      tempTimes.push(
        format(
          parse(
            val,
            val.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
            new Date()
          ),
          "h:mmaa"
        ).toLowerCase()
      )
    );
    tempTimestmrw.map((val) =>
      tempTimes.push(
        format(
          parse(
            val,
            val.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
            new Date()
          ),
          "h:mmaa"
        ).toLowerCase()
      )
    );
    function checkTemporary(date) {
      var a = date.setHours(0, 0, 0, 0);
      var check = false;
      var good = true;
      if (
        array.includes(data.end.split(" ")[0]) ||
        !isNaN(Number(data.end.split(" ")[0]))
      ) {
        recurringDates = getRecurringDates(
          data.end,
          e || !currentMonth ? new Date() : currentMonth
        );
        good = recurringDates.some((val) => isSameDay(new Date(a), val));
        check = true;
      }
      return (
        a >= startt &&
        (!check && data.bookingOption != "indefinitely" ? a <= endd : true) &&
        good &&
        a >= b &&
        !overrideGroupData?.getOverrideGroups.find(
          (val) =>
            isSameDay(new Date(val.date), new Date(date)) &&
            !overrideData?.getOverrides.find(
              (vall) => vall.groupId == val.id
            ) &&
            val.groupId == data.groupId
        ) &&
        !(
          companyData.getCompanyHours.find(
            (obj) =>
              obj.day == format(new Date(addDays(new Date(date), 1)), "EEEE")
          )?.onJob == 0 ||
          !companyData.getCompanyHours.find(
            (obj) =>
              obj.day == format(new Date(addDays(new Date(date), 1)), "EEEE")
          ) ||
          differenceInDays(
            new Date(addDays(new Date(date), 1)).setHours(0, 0, 0),
            new Date().setHours(0, 0, 0)
          ) < 0
        )
      );
    }
    function getRecurringDates(end, currentMonth) {
      const parts = end.split(" ");

      const [recurrence, dateString] = parts;

      // Determine frequency (number of days, weeks, etc. between recurrences)
      const frequency = !isNaN(Number(recurrence)) ? Number(recurrence) : 1;

      let dateIncrementFunction;
      let differenceFunction;

      function differenceInMultiplesOfDays(date1, date2, days) {
        let totalDaysDifference = differenceInDays(date1, date2);
        return Math.round(totalDaysDifference / days);
      }
      if (!isNaN(Number(recurrence))) {
        // If recurrence is a number, use it as frequency in days
        dateIncrementFunction = (date, val) => addDays(date, val);

        differenceFunction = (date1, date2) =>
          differenceInMultiplesOfDays(date1, date2, frequency);
      } else {
        switch (recurrence) {
          case "day":
            dateIncrementFunction = addDays;
            differenceFunction = differenceInDays;
            break;
          case "week":
            dateIncrementFunction = addWeeks;
            differenceFunction = differenceInWeeks;
            break;
          case "month":
            dateIncrementFunction =
              (props.usersData?.calendar || calendar) === "Ethiopian"
                ? habeshaAddMonths
                : addMonths;
            differenceFunction = differenceInMonths;
            break;
          case "year":
            dateIncrementFunction = addYears;
            differenceFunction = differenceInYears;
            break;
          default:
            return [new Date(end)]; // If it's not recurring, return the end date itself
        }
      }

      let dates = [];
      const currentMonthDate = new Date(currentMonth);
      const startDate = new Date(dateString);
      let difference = differenceFunction(currentMonthDate, startDate);

      for (
        let i = Math.ceil(difference - (1 / frequency) * 44) * frequency;
        i <= Math.ceil(difference + (1 / frequency) * 44) * frequency;
        i += frequency
      ) {
        dates.push(dateIncrementFunction(startDate, i));
      }
      return dates;
    }
    var returnn = !(
      companyData.getCompanyHours.find((obj) => obj.day == format(date, "EEEE"))
        ?.onJob == 0 ||
      !companyData.getCompanyHours.find(
        (obj) => obj.day == format(date, "EEEE")
      ) ||
      differenceInDays(date.setHours(0, 0, 0), new Date().setHours(0, 0, 0)) < 0
    )
      ? (a >= startt &&
        (!check && data.bookingOption != "indefinitely" ? a <= endd : true) &&
        good &&
        a >= b &&
        !overrideGroupData?.getOverrideGroups.find(
          (val) =>
            isSameDay(new Date(val.date), new Date(date)) &&
            !overrideData?.getOverrides.find(
              (vall) => vall.groupId == val.id
            ) &&
            val.groupId == data.groupId
        )) ||
      (checkTemporary(new Date(addDays(date, 1))) && tempTimestmrw.length) ||
      (checkTemporary(new Date(subDays(date, 1))) && tempTimesyest.length)
      : false;
    cache.current[a] = returnn;
    return returnn;
  }
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [calendar, setCalendar] = useState("Gregorian");
  const [addRating] = useMutation(ADD_RATING);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [review, setReview] = useState("");
  const [desc, setDesc] = useState("");
  const [rating, setRating] = useState(0);
  const [errors, setErrors] = useState(false);
  function computeRatingPercentages(ratingArray) {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    const percentages = {};
    const total = ratingArray.length;

    // Count the frequency of each rating
    for (let i = 0; i < total; i++) {
      counts[ratingArray[i]] = (counts[ratingArray[i]] || 0) + 1;
    }
    // Calculate the percentage of each rating
    for (let rating in counts) {
      percentages[rating] = total ? (counts[rating] / total) * 100 : 0;
    }

    return percentages;
  }
  const [ratingsDisplay, setRatingsDisplay] = useState([]);
  const [ratings, setRatings] = useState({});
  const [getRatingsDetails] = useMutation(GET_RATING_DETAILS);
  function getCurrentWeekSundayEthiopian(ethDate) {
    const today = ethDate.date; // Assuming .date gives the day of the month
    const currentDay = ethDate.getDay(); // Assuming .day gives the day of the week

    // If today is Sunday (which might be represented differently in Ethiopian calendar)
    if (currentDay === 0) {
      return new Date(converterDateTime.toEuropean(ethDate));
    }
    return new Date(
      subDays(
        converterDateTime.toEuropean(ethDate),
        Math.abs(today - currentDay) + 1
      )
    );
  }
  const getMonthDates = (date) => {
    if (!date) {
      return false;
    }
    let firstDayOfMonth, lastDayOfMonth, firstDayOfCalendar, lastDayOfCalendar;

    if ((props.currentUser?.calendar || calendar) === "Ethiopian") {
      firstDayOfMonth = toEthiopianDateTime(
        new Date(date.getFullYear(), date.getMonth(), 1)
      );
      lastDayOfMonth = toEthiopianDateTime(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
      );

      firstDayOfCalendar = getCurrentWeekSundayEthiopian(
        new ethDateTime(
          1,
          converterDateTime.toEthiopian(date).month,
          converterDateTime.toEthiopian(date).year
        )
      );
      lastDayOfCalendar = addDays(
        converterDateTime.toEuropean(
          new ethDateTime(
            new ethDateTime(
              1,
              converterDateTime.toEthiopian(date).month,
              converterDateTime.toEthiopian(date).year
            ).monthname.includes("Pagume")
              ? typeof converterDateTime.toEuropean(
                new ethDateTime(
                  6,
                  converterDateTime.toEthiopian(date).month,
                  converterDateTime.toEthiopian(date).year
                )
              ) == "string"
                ? 5
                : 6
              : 30,
            converterDateTime.toEthiopian(date).month,
            converterDateTime.toEthiopian(date).year
          )
        ),
        1
      );
    } else {
      firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      firstDayOfCalendar = new Date(
        firstDayOfMonth.getFullYear(),
        firstDayOfMonth.getMonth(),
        firstDayOfMonth.getDate() - firstDayOfMonth.getDay()
      );
      lastDayOfCalendar = new Date(
        lastDayOfMonth.getFullYear(),
        lastDayOfMonth.getMonth(),
        lastDayOfMonth.getDate() + (6 - lastDayOfMonth.getDay())
      );
    }

    let dates = [];
    let currentDate = firstDayOfCalendar;
    while (currentDate <= lastDayOfCalendar) {
      dates.push(new Date(currentDate));
      currentDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + 1
      );
    }
    return dates;
  };
  const [change, setChange] = useState(false);
  function find(date, e) {
    var finalDate = date;
    var monthDates = getMonthDates(finalDate);
    var findIt = monthDates.find((datee) => {
      return isDateGood(datee, e) && isSameMonth(date, datee);
    });
    while (!findIt) {
      finalDate = addMonths(finalDate, 1);
      monthDates = getMonthDates(finalDate);
      findIt = monthDates.find((datee) => {
        return isDateGood(datee, e) && isSameMonth(date, finalDate);
      });
      if (
        finalDate > getEndDate(data.end) &&
        data.end.split(" ")[1] == undefined
      ) {
        return false;
      }
    }
    return new Date(findIt.getFullYear(), findIt.getMonth(), 1);
  }
  const [monthDates, setMonthDates] = useState([]);
  React.useEffect(() => {
    if (
      !(
        loading ||
        overrideLoading ||
        overrideGroupLoading ||
        companyLoading ||
        bookloading
      )
    ) {
      const searchParams = new URLSearchParams(window.location.search);
      const queryParam =
        (props.currentUser?.calendar || calendar) == "Ethiopian"
          ? null
          : searchParams.get("month");
      const queryParam2 =
        (props.currentUser?.calendar || calendar) == "Ethiopian"
          ? null
          : searchParams.get("date");
      if (!currentMonth) {
        var temp = find(
          queryParam ? addDays(new Date(queryParam), 1) : new Date(data.start),
          1
        );
        setCurrentMonth(temp);
        setMonthDates(getMonthDates(temp));
        console.log(temp);
      } else if (queryParam) {
        setCurrentMonth(addMonths(new Date(queryParam), 1));
      }
      if (queryParam2) {
        setSelectedDate(addDays(new Date(queryParam2), 1));
      }
      if (
        queryParam2 &&
        !isDateGood(new Date(addDays(new Date(queryParam2), 1)))
      ) {
        var ready = find(new Date(data.start));
        var temp = getMonthDates(ready);
        setMonthDates(temp);
        var newSelectedDate = temp.find((val) => isDateGood(new Date(val)));
        setCurrentMonth(newSelectedDate);
        setSelectedDate(newSelectedDate);
        searchParams.set(
          "date",
          new Date(newSelectedDate).toISOString().substring(0, 10)
        );
        searchParams.set(
          "month",
          new Date(newSelectedDate).toISOString().substring(0, 7)
        );
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        navigate(newUrl);
      }
      if ((props.currentUser?.calendar || calendar) == "Ethiopian") {
        navigate(window.location.pathname);
      }
    }
  }, [
    loading,
    overrideLoading,
    overrideGroupLoading,
    companyLoading,
    bookloading,
  ]);
  useEffect(() => {
    if (isItLoading) {
      setTimeout(() => {
        setIsItLoading(false);
      }, 600);
    }
  }, [isItLoading]);
  useEffect(() => {
    if (!loading && ratingsData?.getRatings) {
      setRatings(
        computeRatingPercentages(
          ratingsData?.getRatings?.map((val) => val.rating)
        )
      );
      Promise.all(
        ratingsData?.getRatings?.map((val) =>
          getRatingsDetails({
            variables: { ratingId: parseInt(val.id) },
          })
        )
      ).then((values) => {
        const final = values.map((val) => val.data.getRatingDetails);
        setRatingsDisplay(final);
      });
    }
  }, [loading]);
  if (loading || overrideLoading || overrideGroupLoading || companyLoading) {
    return "loading";
  } else if (error || overrideError || overrideGroupError || companyError) {
    return <Error />;
  }
  function getEndDate(data) {
    // Split the data.end string into parts
    const parts = data.split(" ");
    // Check if the first part is one of the recurrence keywords
    if (
      ["week", "month", "year", "day"].includes(parts[0]) ||
      parseInt(parts[0]) !== NaN
    ) {
      // If it is, join the rest of the parts back together, convert to a Date object, and return it
      const dateStr = parts[1] || parts[0];
      return new Date(dateStr);
    } else {
      // If it's not one of the keywords, throw an error or return a default value
      // This is up to you to decide, based on what you want to do in this case

      console.log(`Unrecognized recurrence keyword: ${parts[0]}`);
      return new Date(parts[1] || parts[0]);
    }
  }
  if (props.BookPage) {
    return <props.BookPage isDateGood={isDateGood} {...props} />;
  }
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {!data || !props.usersData ? (
        ""
      ) : (
        <CancelModal
          showCancelModal={showCancelModal}
          setShowCancelModal={setShowCancelModal}
          bookingId={bookingId}
          setBookingId={setBookingId}
          review={review}
          setReview={setReview}
          desc={desc}
          setDesc={setDesc}
          rating={rating}
          setRating={setRating}
          errors={errors}
          addRating={addRating}
          data={data}
          refetch={refetch}
          setErrors={setErrors}
        />
      )}
      {!data || !props.usersData ? (
        <NotFound />
      ) : selectedDate && isSmallScreen ? (
        <Card
          className="event-card"
          style={{
            display: "flex",
            borderRadius: "20px",
            flexDirection: isSmallScreen && "column",
            width: "90%",
            alignItems: isSmallScreen && "center",
            maxWidth: selectedDate ? "1000px" : "800px",
            justifyContent: "space-between",
            margin: "0 0 20px 0",
            padding: "21px 0",
          }}
        >
          <div style={{ width: "90%", paddingTop: "20px" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              <div style={{ flex: 1 }}>
                <IconButton
                  onClick={() => {
                    const searchParams = new URLSearchParams(
                      window.location.search
                    );
                    searchParams.delete("date");
                    const newUrl = `${window.location.pathname
                      }?${searchParams.toString()}`;
                    navigate(newUrl);
                    setSelectedDate(null);
                  }}
                  style={{ border: "1px solid lightgrey" }}
                >
                  <ArrowBack />
                </IconButton>
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "10px",
                  padding: "20px 0px",
                }}
              >
                <h3 style={{ margin: 0 }}>{format(selectedDate, "EEEE")}</h3>
                <Typography style={{ textAlign: "center" }}>
                  {format(selectedDate, "MMMM d, yyyy")}
                </Typography>
              </div>
              <div style={{ flex: 1 }}></div>
            </div>
            <Divider variant="horizontal" style={{ width: "100%" }} />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px 0px",
              }}
            >
              <h2>Select a Time</h2>
              <Typography>
                Length:{" "}
                {data.length > 59
                  ? Number((data.length / 60).toFixed(1)) +
                  (data.length < 120 ? " hr" : " hrs")
                  : data.length + " mins"}
              </Typography>
            </div>
            <Times
              link={id}
              start={data.start}
              end={data.end}
              id={data.id}
              isDateGood={isDateGood}
              calendar={calendar}
              decodedToken={props.currentUser}
              currentUser={props.usersData}
              selectedDate={selectedDate}
              smallScreen="full"
              noDate={true}
              data={data}
              setSpilledDates={props.setSpilledDates}
              spilledDates={props.spilledDates}
              startDate={new Date(data.start)}
              endDate={getEndDate(data.end)}
              setSelectedDate={setSelectedDate}
            />
          </div>
        </Card>
      ) : (
        <Card
          className="event-card"
          style={{
            borderRadius: "20px",
            display: "flex",
            flexDirection: (isSmallScreen || isSmallScreen2) && "column",
            width: "90%",
            alignItems: (isSmallScreen || isSmallScreen2) && "center",
            maxWidth: selectedDate ? "1000px" : "800px",
            justifyContent: "space-between",
            minHeight: "800px",
            margin: (isSmallScreen || isSmallScreen2) && "0 0 20px 0",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              padding: "20px 30px",
              flexDirection: "column",
              background: "white",
              zIndex: 2,
              alignItems: (isSmallScreen || isSmallScreen2) && "center",
              textAlign: (isSmallScreen || isSmallScreen2) && "center",
              width: (isSmallScreen || isSmallScreen2) && "90%",
              gap: "25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection:
                  isSmallScreen || isSmallScreen2 ? "row" : "column",
                width: "100%",
                gap: isSmallScreen || isSmallScreen2 ? "0px" : "20px",
              }}
            >
              {window.location.search.includes("back=1") ? (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    width: "100%",
                    flex: 1,
                  }}
                >
                  <IconButton
                    onClick={() => {
                      navigate("/" + user);
                    }}
                    style={{ border: "1px solid lightgrey" }}
                  >
                    <ArrowBack />
                  </IconButton>
                </div>
              ) : (
                ""
              )}
              <div
                style={{
                  overflowWrap: "break-word",
                  width: isSmallScreen && "70%",
                  display: "flex",
                  flexDirection: "column",
                  flex: 1.25,
                  alignItems:
                    !window.location.search.includes("back=1") &&
                    (isSmallScreen || isSmallScreen2) &&
                    "center",
                }}
              >
                <Avatar
                  sx={{ width: 55, height: 55 }}
                  style={{
                    border: "4px solid white",
                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                  }}
                >
                  {props.usersData.username.toUpperCase().slice(0, 1)}
                </Avatar>
              </div>
            </div>
            <div
              style={{
                overflowWrap: "break-word",
                width: isSmallScreen && "70%",
                textAlign: (isSmallScreen || isSmallScreen2) && "center",
              }}
            >
              <h1
                className="margin0"
                style={{
                  margin: (isSmallScreen || isSmallScreen2) && 0,
                }}
              >
                {data.name}
              </h1>
            </div>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: (isSmallScreen || isSmallScreen2) && "center",
                alignItems: "center",
              }}
            >
              <AccessTimeFilled />
              <h4 className="margin0">
                {data.length > 59
                  ? Number((data.length / 60).toFixed(1)) +
                  (data.length < 120 ? " hr" : " hrs")
                  : data.length + " mins"}
              </h4>
            </div>{" "}
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                justifyContent: (isSmallScreen || isSmallScreen2) && "center",
              }}
            >
              {data.locationType.includes("In") ? <LocationOn /> : <Phone />}
              <h4 className="margin0">{data.locationType}</h4>
            </div>
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                justifyContent: (isSmallScreen || isSmallScreen2) && "center",
              }}
            >
              <Person />
              <h4 className="margin0">Made by {props.usersData.username}</h4>
            </div>
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "left",
                alignItems: (isSmallScreen || isSmallScreen2) && "center",
                flexDirection: "column",
                width: "80%",
              }}
            >
              <Typography
                className="margin0"
                style={{
                  fontSize: "19px",
                  maxWidth: !(isSmallScreen || isSmallScreen2)
                    ? "263px"
                    : "100%",
                  wordWrap: "break-word",
                  textAlign: "left",
                }}
              >
                {data.desc.slice(0, showMore ? 300 : data.desc.length)}
              </Typography>
              <h4
                className="margin0"
                style={{
                  cursor: "pointer",
                  display: showMore === null && "none",
                }}
                onClick={() => {
                  showMore !== null && setShowMore(!showMore);
                }}
              >
                Show {showMore ? "more" : "less"}
              </h4>
            </div>
            <div
              style={
                isSmallScreen || isSmallScreen2
                  ? {
                    width: "100%",
                    maxWidth: "300px",
                  }
                  : {}
              }
              className={isSmallScreen || isSmallScreen2 ? "flex column" : ""}
            >
              <Box mb={2}>
                <div
                  className="width100 flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <Typography
                    variant="h6"
                    gutterBottom
                    className="align flex font"
                  >
                    Ratings {"(" + ratingsData?.getRatings?.length + ")"}
                  </Typography>
                  <IconButton onClick={() => setShowCancelModal(true)}>
                    <Add />
                  </IconButton>
                </div>
                {[1, 2, 3, 4, 5].reverse().map((star) => (
                  <Box key={star} display="flex" alignItems="center" mb={1}>
                    <Typography variant="body2" style={{ width: 20 }}>
                      {star}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={ratings[star] ? ratings[star] : 0}
                      style={{ flex: 1, marginLeft: 10 }}
                    />
                  </Box>
                ))}
              </Box>{" "}
              <Box>
                <div
                  className="width100 flex"
                  style={{ justifyContent: "space-between" }}
                >
                  {isSmallScreen || isSmallScreen2 ? (
                    <Link
                      href={
                        window.location.pathname +
                        (window.location.pathname[
                          window.location.pathname.length - 1
                        ] == "/"
                          ? ""
                          : "/") +
                        "ratings"
                      }
                    >
                      View all ratings
                    </Link>
                  ) : (
                    ratingsDisplay.slice(0, 1).map((star) => (
                      <Box
                        key={star.id}
                        mb={1}
                        display="flex"
                        flexDirection="column"
                      >
                        <div
                          className={
                            "flex align" +
                            (isSmallScreen || isSmallScreen2 ? " justify" : "")
                          }
                          style={{ gap: "10px" }}
                        >
                          <Typography
                            className="font"
                            style={{ fontSize: "30px" }}
                          >
                            {star.name}
                          </Typography>
                          <Rating readOnly value={star.rating} />
                        </div>
                        <div
                          className="flex column"
                          style={{ alignItems: "flex-start" }}
                        >
                          <Typography
                            className="font"
                            style={{ fontSize: "20px" }}
                          >
                            {star.review}
                          </Typography>
                          <Typography
                            className="font2"
                            style={{
                              fontSize: "18px",
                              maxWidth:
                                isSmallScreen || isSmallScreen2
                                  ? "200px"
                                  : "400px",
                              wordBreak: "break-word",
                            }}
                          >
                            {star.desc}
                          </Typography>
                        </div>
                      </Box>
                    ))
                  )}
                </div>
                {isSmallScreen || isSmallScreen2 ? (
                  ""
                ) : (
                  <Link
                    href={
                      window.location.pathname +
                      (window.location.pathname[
                        window.location.pathname.length - 1
                      ] == "/"
                        ? ""
                        : "/") +
                      "ratings"
                    }
                  >
                    View all ratings
                  </Link>
                )}
              </Box>
            </div>
          </div>
          <Divider
            style={{
              width: (isSmallScreen || isSmallScreen2) && "100%",
            }}
            orientation={
              isSmallScreen || isSmallScreen2 ? "horizontal" : "vertical"
            }
          />
          <div
            style={{
              flex: selectedDate ? 2 : 1,
              padding: "20px",
              paddingRight: selectedDate ? 0 : "20px",
              width:
                !selectedDate && (isSmallScreen || isSmallScreen2)
                  ? "70%"
                  : "90%",
              maxWidth: !selectedDate ? "550px" : "700px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "98%",
              }}
            >
              <h3 style={{ paddingLeft: "10px" }}>Select a Date & Time</h3>
              <p
                style={{
                  display: props.currentUser ? "none" : "flex",
                  alignItems: "center",
                }}
              >
                <Language />
                <Select
                  value={calendar}
                  onChange={(e) => {
                    setChange(true);
                    setCalendar(e.target.value);
                  }}
                  sx={{
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": {
                      border: "none !important",
                    },
                  }}
                >
                  <MenuItem value="Gregorian">EN</MenuItem>
                  <MenuItem value="Ethiopian">ET</MenuItem>
                </Select>
              </p>
            </div>
            <div>
              <MiniCalendar
                onChange={handleDateChange}
                startDate={new Date(data.start)}
                endDate={getEndDate(data.end)}
                start={data.start}
                end={data.end}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                link={id}
                id={data.id}
                isDateGood={isDateGood}
                monthDates={monthDates}
                find={find}
                isItLoading={isItLoading}
                datas={data}
                setCurrentMonth={setCurrentMonth}
                currentMonth={currentMonth}
                calendar={calendar}
                setSpilledDates={props.setSpilledDates}
                setMonthDates={setMonthDates}
                spilledDates={props.spilledDates}
                currentUser={props.usersData}
                change={change}
                decodedToken={props.currentUser}
                setIsItLoading={setIsItLoading}
                height={isSmallScreen2 ? "464px" : "700px"}
                width="100%"
              />
            </div>
          </div>
          {/* Add

your custom content here */}
        </Card>
      )}
    </div>
  );
};

export default EventPage;
